export default __webpack_public_path__ + "static/cactus2-0f5efb478793fb846cd5045ee8d2e6e9.png";